firebird.controller('customBrandingModalCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    'Upload',
    'logService',
    'meetingService',
    'socketService',
    'analyticsWrapperService',
    'helperService',
    'growlService',
    'localizationService',
    'brandingService',
    function (
        $rootScope,
        $scope,
        $window,
        Upload,
        logService,
        meetingService,
        socketService,
        analyticsWrapperService,
        helperService,
        growlService,
        localizationService,
        brandingService
    ) {
        var self = this;

        self.supportedFormats = ['png', 'jpg', 'jpeg'];

        self.savedBackgroundUrl = self.previewBackgroundUrl = meetingService.getBrandingBackgroundUrl() || '';
        self.savedLogoUrl = self.previewLogoUrl = meetingService.getBrandingLogoUrl() || '';

        self.temporaryFiles = {
            logo: null,
            background: null
        };

        self.removeFile = {
            logo: false,
            background: false
        };

        self.isSaving = false;

        self._onBrandInformation = _onBrandInformation;

        self.updateBrandingPreview = updateBrandingPreview;
        self.removeLogo = removeLogo;
        self.removeBackground = removeBackground;
        self.cancel = discardChanges;
        self.save = saveChanges;
        self.updateImages = updateImages;

        self.onShowModal = onShowModal;
        self.onHideModal = onHideModal;
        self.modalState = 'closed';
        self.fileTypeIsSupported = fileTypeIsSupported;

        // Flag used for Redesign only
        self.shouldInitialize = true;
        self.needsSaving = false; // Initially does not need saving until branding is changed

        $scope.$on('show-modal', self.onShowModal);
        $scope.$on('hide-modal', self.onHideModal);
        $scope.$on('branding-info-updated', self._onBrandInformation);
        $scope.$on('settings-view-state-change', onSettingsViewStateChanged);
        $scope.$on('settings-modal-closed', onSettingsModalClosed);

        ////////////////////////

        // Cancel
        function discardChanges() {
            self.previewBackgroundUrl = self.savedBackgroundUrl;
            self.previewLogoUrl = self.savedLogoUrl;
            self.temporaryFiles.logo = null;
            self.temporaryFiles.background = null;
            self.removeFile.logo = false;
            self.removeFile.background = false;
        }

        function _onBrandInformation() {
            var data = meetingService.getBrandingInfo();

            self.savedBackgroundUrl = self.previewBackgroundUrl = data.backgroundURL;
            self.savedLogoUrl = self.previewLogoUrl = data.inMeetingLogoURL;

            digest();
        }

        function updateImages() {
            // Check if anything needs to be updated
            if (self.savedBackgroundUrl === self.previewBackgroundUrl && self.savedLogoUrl === self.previewLogoUrl) {
                self.isSaving = false;
                return;
            }

            growlService.show(localizationService.translate('HEADER.NOTIFICATIONS.BRANDING_IMAGE_LOADING'), 'success');

            var postUrl =
                helperService.getLocationProtocol() +
                '://api.' +
                helperService.getLocationHost() +
                '/api/meetings/' +
                meetingService.getMeetingCode() +
                '/branding-info/';
            var uploadParams = {
                logo: self.temporaryFiles.logo || self.removeFile.logo.toString(),
                background: self.temporaryFiles.background || self.removeFile.background.toString()
            };

            Upload.upload({
                url: postUrl,
                data: uploadParams
            }).then(
                function (resp) {
                    growlService.show(
                        localizationService.translate('HEADER.NOTIFICATIONS.BRANDING_IMAGE_UPDATED'),
                        'success'
                    );

                    // Logo change
                    if (self.savedLogoUrl !== self.previewLogoUrl) {
                        if (self.previewLogoUrl === '') {
                            analyticsWrapperService.eventTrack('Meeting - Branding - logo removed', {
                                category: 'Custom Branding'
                            });
                        } else {
                            analyticsWrapperService.eventTrack('Meeting - Branding - logo updated', {
                                category: 'Custom Branding'
                            });
                        }
                    }

                    // Background change
                    if (self.savedBackgroundUrl !== self.previewBackgroundUrl) {
                        if (self.previewBackgroundUrl === '') {
                            analyticsWrapperService.eventTrack('Meeting - Branding - background removed', {
                                category: 'Custom Branding'
                            });
                        } else {
                            analyticsWrapperService.eventTrack('Meeting - Branding - background updated', {
                                category: 'Custom Branding'
                            });
                        }
                    }

                    self.temporaryFiles.logo = null;
                    self.temporaryFiles.background = null;

                    // Send branding-image-updated meeting event
                    var msg = {
                        message: 'branding-image-updated',
                        data: {}
                    };
                    socketService.send(msg);

                    self.isSaving = false;

                    logService.log('Success ' + 'uploaded. Response: ' + resp.data);

                    analyticsWrapperService.eventTrack('Meeting - Files - Upload Completed', {
                        category: 'Custom Branding'
                    });
                },
                function (resp) {
                    logService.log('Error status: ' + resp.status);

                    var closeButtonHtmlUploadFailure =
                        '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                    $window.swal({
                        title:
                            closeButtonHtmlUploadFailure +
                            localizationService.translate('HEADER.DIALOG.BRANDING_IMAGE_UPDATE_FAILED'),
                        text: localizationService.translate('HEADER.DIALOG.BRANDING_IMAGE_UPDATE_FAILED_MESSAGE'),
                        type: 'error',
                        showCancelButton: false,
                        confirmButtonColor: brandingService.getBaseColor(),
                        confirmButtonText: localizationService.translate('COMMON.OK_TEXT'),
                        closeOnConfirm: true,
                        html: true,
                        imageUrl: 'img/redesign/modal/pop-up-pic-error.svg'
                    });

                    self.isSaving = false;
                    analyticsWrapperService.eventTrack('Meeting - Files - Upload Errored', {
                        category: 'Custom Branding'
                    });
                },
                function (evt) {
                    if (evt.total > 0) {
                        var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
                        logService.log('progress: ' + progressPercentage + '% ');
                    }
                }
            );
        }

        function saveChanges() {
            self.isSaving = true;
            self.updateImages();
        }

        function removeLogo() {
            self.previewLogoUrl = '';

            self.removeFile.logo = true;
            self.temporaryFiles.logo = null;
        }

        function removeBackground() {
            self.previewBackgroundUrl = '';

            self.removeFile.background = true;
            self.temporaryFiles.background = null;
        }

        function updateBrandingPreview(file, fileEvent, type) {
            // Check if select event fired too many times
            if (file === null && fileEvent !== undefined && fileEvent.type == 'click') {
                //work around for ngf-select firing multiple times on click after there was previous attempt at selecting an not accepted file
                return;
            }

            // Check if file type is supported
            if (file === null || (file !== null && self.fileTypeIsSupported(file.name) === false)) {
                var closeButtonHtmlInvalidFile =
                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                $window.swal({
                    title:
                        closeButtonHtmlInvalidFile +
                        localizationService.translate('HEADER.DIALOG.BRANDING_IMAGE_INVALID_FILE'),
                    text: localizationService.translate('HEADER.DIALOG.BRANDING_SUPPORTED_FILES'),
                    showCancelButton: false,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('COMMON.OK_TEXT'),
                    closeOnConfirm: true,
                    html: true,
                    imageUrl: 'img/redesign/modal/pop-up-pic-error.svg'
                });

                analyticsWrapperService.eventTrack('Meeting - Files - Bad File Type', {
                    category: 'Custom Branding'
                });

                return;
            }

            // Check if file is too big
            if (file.size > 2 * 1024 * 1024) {
                var closeButtonHtmlTooBig =
                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                $window.swal({
                    title: closeButtonHtmlTooBig + localizationService.translate('HEADER.DIALOG.BRANDING_FILE_TOO_BIG'),
                    text: localizationService.translate('HEADER.DIALOG.BRANDING_FILE_TOO_BIG_MESSAGE'),
                    showCancelButton: false,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('COMMON.OK_TEXT'),
                    closeOnConfirm: true,
                    html: true,
                    imageUrl: 'img/redesign/modal/pop-up-pic-error.svg'
                });

                return;
            }

            // Read the file
            var reader = new FileReader();
            reader.onload = function (fileRead) {
                if (type == 1) {
                    // Branding background (type 1)
                    self.previewBackgroundUrl = fileRead.target.result;
                    self.removeFile.background = false;
                    self.temporaryFiles.background = file;
                } else if (type == 2) {
                    // Branding logo (type 2)
                    self.previewLogoUrl = fileRead.target.result;
                    self.removeFile.logo = false;
                    self.temporaryFiles.logo = file;
                }

                digest();
            };
            reader.readAsDataURL(file);
        }

        function fileTypeIsSupported(fileName) {
            if (fileName === null || fileName === undefined) {
                return false;
            }
            var extension = fileName.split('.').reverse()[0].toLowerCase();
            for (var i = 0; i < self.supportedFormats.length; i++) {
                if (self.supportedFormats[i] === extension) {
                    return true;
                }
            }
            return false;
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('customBranding') !== -1) {
                self.modalState = 'closed';
                if (self.isSaving !== true) {
                    self.cancel();
                }
            }

            digest();
        }

        function onShowModal(e, modalName) {
            if (modalName === 'customBranding') {
                self.savedBackgroundUrl = self.previewBackgroundUrl = meetingService.getBrandingBackgroundUrl() || '';
                self.savedLogoUrl = self.previewLogoUrl = meetingService.getBrandingLogoUrl() || '';

                self.modalState = 'open';
            }
        }

        function onSettingsViewStateChanged(e, data) {
            if (data) {
                var tabName = 'custom-branding';

                if (data.openedTab === tabName) {
                    logService.log('Custom Branding Tab opened');

                    //Should only initialize ctrl properties if this tab gets opened for the first time...
                    //If switching to another tab and back to Custom Branding, we do not want to re-initialize
                    if (self.shouldInitialize) {
                        self.shouldInitialize = false;
                        self.onShowModal({}, 'customBranding');
                    }
                } else if (data.closedTab === tabName) {
                    logService.log('Custom Branding Tab closed');
                }
            }
        }

        function onSettingsModalClosed(e, data) {
            if (data.applyChanges === true) {
                self.save();
            } else {
                self.cancel();
            }

            self.shouldInitialize = true;
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
